import contactContent from './content/contact.json';

const contactMock = {
    layoutType: 2,
    data: {
        name: "contact-us",
        layoutType: 2,
        areasList: [
            {
                id: 'contact-page-area',
                name: 'Content',
                componentName: 'Comp:ContactPage',
                content: JSON.stringify(contactContent),
            },
        ],
    },
};

export default contactMock;
